import React, { useState, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import MessageTypeWrapper from '../MessageTypeWrapper'
import MessageImageViewer from './Common/MessageImageViewer'

const useStyles = makeStyles(() => ({
  bubble: {
    padding: '8px 15px 5px 15px !important'
  },
  message: {
    alignItems: 'center'
  },
  messageUserInfo: {
    marginLeft: 5
  },
  preview: {
    marginBottom: 20
  },
  footerContainer: {
    marginTop: 5,
    alignSelf: 'flex-end'
  }
}))

const BeforeAfterMessage = ({
  id,
  content,
  isLocal,
  cache,
  alignLeft,
  name,
  userType,
  isFirstMessage,
  isLastMessage,
  timestamp,
  withMessageActions,
  readStatus
}) => {
  const classes = useStyles()
  const jsonContent = useMemo(() => JSON.parse(content), [content])

  const [isImageViewerOpen, setImageViewerState] = useState(false)

  return (
    <MessageTypeWrapper
      id={id}
      isFirstMessage={isFirstMessage}
      isLastMessage={isLastMessage}
      alignLeft={alignLeft}
      name={name}
      userType={userType}
      className={classes.bubble}
      infoClassName={classes.messageUserInfo}
      withMessageActions={withMessageActions}
    >
      <MessageImageViewer
        messageId={id}
        isLocal={isLocal}
        image={jsonContent.shareAsset}
        text={jsonContent.text}
        isImageViewerOpen={isImageViewerOpen}
        setImageViewerState={setImageViewerState}
        cache={cache}
        timestamp={timestamp}
        alignLeft={alignLeft}
        messageClassName={classes.message}
        footerContainerClassName={classes.footerContainer}
        previewClassName={classes.preview}
        name={name}
        readStatus={readStatus}
      />
    </MessageTypeWrapper>
  )
}

export default React.memo(BeforeAfterMessage)
